import { combineReducers } from 'redux';
import collectionsReducer from '../collections/reducer';
import gigsViewReducer from '../gigsView/reducer';
import sellersViewReducer from '../sellersView/reducer';
import collectionReducer from '../collection/reducer';

export default ({ collectionData, gigsData, sellersData }) =>
    combineReducers({
        collection: collectionReducer(collectionData),
        collections: collectionsReducer(),
        gigsView: gigsViewReducer(gigsData),
        sellersView: sellersViewReducer(sellersData),
    });
